module.exports = __webpack_public_path__ + "static/media/check-rounded-white-bg.c090b247.svg";